import React, { useEffect, useState } from 'react'
import { rbsApi } from '../api/rbsApi'
import { useTranslation } from 'react-i18next';

export const useAxiosPost = (url, object, handleFormSubmitted) => {

    const [t, i18n] = useTranslation("global");
  
    const [state, setState] = useState(
        {
            data: null,
            isLoading: true,
            error: null
        }
    )

    const postAxios = async () => {
        setState({
            ...state,
            isLoading: true
        })

        try{
           const { data } = rbsApi.post(url, object)
                .then( () => {
                    setState(
                        {
                            data: data,
                            isLoading: false,
                            error: null,
                        }
                    );
                    alert(t('axios.message'));
                    window.location.href = window.location;

                })
                .catch( error => {
                    setState({
                        data: null,
                        isLoading: false,
                        error: error,
                      });
                });
           
        } catch (error) {
            setState({
              data: null,
              isLoading: false,
              error: error,
            });
        } finally {
            handleFormSubmitted(false); // Llama a la función de callback para restablecer formSubmitted
        }

            
    }

    useEffect(() => {
      if( !url ){
        setState({
              data: null,
              isLoading: false,
              error: null,
            });

            return;
        };
        postAxios();
    }, [url])
  
    return {
        data:  state.data,
        isLoading: state.isLoading,
        error: state.error
    }
}

export const useAxiosPost2 = (url, object, handleFormSubmitted) => {

    const [t, i18n] = useTranslation("global");
  
    const [state, setState] = useState(
        {
            data2: null,
            isLoading2: true,
            error2: null
        }
    )

    const postAxios = async () => {
        setState({
            ...state,
            isLoading2: true
        })

        try{
           const { data } = rbsApi.post(url, object)
                .then( () => {
                    setState(
                        {
                            data2: data,
                            isLoading2: false,
                            error2: null,
                        }
                    );

                })
                .catch( error => {
                    setState({
                        data2: null,
                        isLoading2: false,
                        error2: error,
                      });
                });
           
        } catch (error) {
            setState({
              data2: null,
              isLoading2: false,
              error2: error,
            });
        } finally {
            handleFormSubmitted(false); // Llama a la función de callback para restablecer formSubmitted
        }

            
    }

    useEffect(() => {
      if( !url ){
        setState({
              data2: null,
              isLoading2: false,
              error2: null,
            });

            return;
        };
        postAxios();
    }, [url])
  
    return {
        data2:  state.data,
        isLoading2: state.isLoading,
        error2: state.error
    }
}
